import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import moment from 'moment'
import { addLocaleData } from 'react-intl'
import queryString from 'query-string'

import { getDictonary, toDash, toUnderscore, getLocaleFromStore } from 'utils/intl'
import { apiPersons } from 'helpers/decorators/api'
import { parseAuthCode } from 'utils/authCode'
import store from "store";

function hoc() {
  return ComposedComponent => {
    @apiPersons({
      locales: true
    })
    @connect(({ auth }) => ({
      user: auth.user
    }))
    class Locales extends Component {
      static propTypes = {
        location: PropTypes.object.isRequired,
        changeLocale: PropTypes.func.isRequired,
        locale: PropTypes.object.isRequired,
        user: PropTypes.object,
        persons: PropTypes.object
      }

      state = {
        localeFromUrl: null
      }

      // investigate why view is not refreshed when WillMount is changed to didMount -> then rewrite this to didMount
      componentWillMount() {
        const { persons } = this.props

        const cachedLocales = getLocaleFromStore()

        const query = queryString.parse(get(this.props, 'location.search'))
        let urlLocale = null

        const locale =
          get(cachedLocales, 'code') || get(this.props, 'locale.code')

        moment.locale(locale)

        if (get(query, 'locale')) {
          this.handleSetLocaleFromUrl(get(query, 'locale'))
          urlLocale = get(query, 'locale')
        }

        if (locale !== 'en-gb') {
          this.handleLocale(locale)
        }

        if (
          (get(cachedLocales, 'code') &&
            get(cachedLocales, 'code') !== this.props.locale.code) ||
          (urlLocale && get(cachedLocales, 'code') !== urlLocale)
        ) {
          let activeLocale = cachedLocales

          if (urlLocale) {
            activeLocale = this.handleGetLocalesObject(
              persons.locales,
              urlLocale
            )
          }
          this.props.changeLocale(activeLocale)
        }
      }

      componentWillReceiveProps(nextProps) {
        const { user, locale, persons } = this.props
        const personRole = get(nextProps, 'user.personLocale')
        const localesAreLoaded =
          persons.locales.length === 0 && nextProps.persons.locales.length > 0
        const userIsLoaded =
          !get(user, 'personLocale') && get(nextProps, 'user.personLocale')

        // ignore user locale if authcode is present
        const authCode = parseAuthCode(nextProps)

        if (authCode) {
          return
        }

        if (localesAreLoaded || userIsLoaded) {
          if (
            locale.code !== nextProps.locale.code || locale.code !== personRole
          ) {
            const activeLocale = personRole || nextProps.locale.code
            const localeObject = this.handleGetLocalesObject(
              nextProps.persons.locales,
              activeLocale
            )

            this.handleLocale(activeLocale)
            const storedLocale = getLocaleFromStore()
            const localeToChange = localeObject || storedLocale
            this.props.changeLocale(localeToChange)
          }
        }
      }

      handleGetLocalesObject = (locales = [], localeCode) =>
        locales.filter(item => item.code === toUnderscore(localeCode))[0]

      handleSetLocaleFromUrl = locale => {
        // this.props.changeLocale({ code: locale })
        this.setState({ localeFromUrl: toDash(locale) })
        this.handleLocale(toDash(locale))
      }

      handleLocale = locale => {
        addLocaleData(getDictonary(locale))
        moment.locale(locale)
      }

      render() {
        return <ComposedComponent {...this.props} {...this.state} />
      }
    }
    return Locales
  }
}

export default hoc
